import { render, staticRenderFns } from "./associated_customer.vue?vue&type=template&id=8a9d25ae&scoped=true"
import script from "./associated_customer.vue?vue&type=script&lang=js"
export * from "./associated_customer.vue?vue&type=script&lang=js"
import style0 from "./associated_customer.vue?vue&type=style&index=0&id=8a9d25ae&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d25ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a9d25ae')) {
      api.createRecord('8a9d25ae', component.options)
    } else {
      api.reload('8a9d25ae', component.options)
    }
    module.hot.accept("./associated_customer.vue?vue&type=template&id=8a9d25ae&scoped=true", function () {
      api.rerender('8a9d25ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/position_information/associated/associated_customer/associated_customer.vue"
export default component.exports